import {
  CalendarDays,
  ChartNoAxesColumn,
  ClipboardList,
  HeartPulse,
  Inbox,
  Search,
  Settings,
  type LucideIcon,
} from "lucide-react";

/**
 * The shape of the primary navigation, shared by both frontends (R22 T12).
 *
 * **The information architecture is the part that must not be duplicated.**
 * Which sections exist, what they are called and which glyph each one carries
 * is a product decision; the markup that renders them is not, and it differs
 * because each frontend has its own router. So the vocabulary lives here and
 * the two `AppNav` components are free to be ordinary components.
 *
 * Icons are looked up from a string key rather than passed in, because the Next
 * side of this is a client component and a server component cannot hand it a
 * function.
 */

export type NavIcon =
  | "search"
  | "bookings"
  | "care"
  | "schedule"
  | "dashboard"
  | "settings"
  | "queue";

export interface NavItem {
  href: string;
  label: string;
  icon: NavIcon;
  /** Shown as a count next to the label, e.g. pending requests. */
  badge?: number;
}

export const ICONS: Record<NavIcon, LucideIcon> = {
  search: Search,
  bookings: Inbox,
  care: HeartPulse,
  schedule: CalendarDays,
  dashboard: ChartNoAxesColumn,
  settings: Settings,
  queue: ClipboardList,
};

